<template>
  <div class="intro">
    <a href="#" class="skipper" @click.prevent="skipIntro"></a>
    <video v-bind:class="{ visible: isPlaying }" ref="video" class="video" src="../assets/ne01-s1-intro.mp4" muted></video>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  props: ['stationData'],
  data: () => {
    return {
      isPlaying: false,
      voiceOver: null,
      videoEnded: false,
      voiceOverEnded: false
    }
  },
  mounted() {
    window.setTimeout(() => {
      this.$refs.video.play();
      this.playVoiceOver();
    }, 1000);

    this.$refs.video.addEventListener('play', (e) => {
      window.setTimeout(() => {
        this.isPlaying = true;
      }, 200);
    });
    this.$refs.video.addEventListener('ended', (e) => {
      this.videoEnded = true;
      if (this.voiceOverEnded) {
        this.$emit('introEnded');
      }
    });
  },
  methods: {
    skipIntro() {
      this.$emit('introEnded');
    },
    playVoiceOver() {
      this.voiceOver = new Howl({
        src: [this.stationData.intro_track],
        autoplay: true
      });
      this.voiceOver.on('end', () => {
        this.voiceOverEnded = true;
        if (this.videoEnded) {
          this.$emit('introEnded');
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

.intro {
  background: #061217;
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.skipper {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3rem;
  background: transparent;
  z-index: 2;
}
.video {
  display: none;
  width: 100%;
  height: 100%;
  object-fit: cover;

  &.visible {
    display: block;
  }
}

</style>
